import { useMutation, useQuery } from '@tanstack/react-query';
import { api } from '../../../../api';
import { connectPremiumBonus, discoverPremiumBonus, getPremiumBonus } from '../../../../config/api';
import { useRestaurantId } from '../../../../selectors/RestaurantSelectors';
import { IPremiumBonusType } from '../../../../types/ICabinetStore';

export const getGuestPremiumBonus = (restaurantId: number, guestPhoneNumber: number) =>
  api.get(getPremiumBonus(restaurantId, guestPhoneNumber), { timeout: 5000 }).then((r) => r);

export const getConnectPremiumBonus = (restaurantId: number) =>
  api.post(connectPremiumBonus(restaurantId)).then((r) => r);

export const getDiscoverPremiumBonus = (restaurantId: number) =>
  api.post(discoverPremiumBonus(restaurantId)).then((r) => r);

export const deleteDiscoverPremiumBonus = (restaurantId: number) =>
  api.delete(connectPremiumBonus(restaurantId)).then((r) => r);

export const useConnectRestaurantToPremiumBonus = () => {
  const restaurantId = useRestaurantId();

  return useMutation({
    mutationFn: () => {
      if (typeof restaurantId !== 'number') {
        return Promise.reject(new Error('restaurantId is required'));
      }
      return getConnectPremiumBonus(restaurantId);
    },
    mutationKey: ['connectPremiumBonus', restaurantId],
  });
};

export const useDeleteDiscoverRestaurantToPremiumBonus = () => {
  const restaurantId = useRestaurantId();

  return useMutation({
    mutationFn: () => {
      if (typeof restaurantId !== 'number') {
        return Promise.reject(new Error('restaurantId is required'));
      }
      return deleteDiscoverPremiumBonus(restaurantId);
    },
    mutationKey: ['deleteDiscoverPremiumBonus', restaurantId],
  });
};

export const useGetDiscoverRestaurantToPremiumBonus = (status?: IPremiumBonusType) => {
  const restaurantId = useRestaurantId();

  return useQuery({
    refetchInterval: ['CONNECTED', 'READY_TO_CONNECT'].indexOf(status) === -1 ? 5000 : 10000,
    queryFn: () => {
      if (typeof restaurantId !== 'number') {
        return Promise.reject(new Error('restaurantId is required'));
      }
      return getDiscoverPremiumBonus(restaurantId);
    },
    queryKey: ['getDiscoverPremiumBonus', restaurantId],
  });
};
